import { Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { ReturnAnalyticsApi } from "../../../apis";
import { ListState } from "../../ui";
import { reasonLabel } from "../atoms";
import { DetailCard } from "../detail-card";
import { BarList } from "./bar-list";

interface IProps {
  dateFromIso?: string;
  dateToIso?  : string;
}

export function ReasonBreakdownChart({ dateFromIso, dateToIso }: IProps) {
  const { t } = useTranslation("returns");
  const { data, error, mutate } = useSWR(
    ["returns.breakdown.reason", dateFromIso, dateToIso],
    () => ReturnAnalyticsApi.breakdown({ dimension: "reason", dateFrom: dateFromIso, dateTo: dateToIso }),
    { revalidateOnFocus: false }
  );

  const items = (data?.buckets ?? []).map((b, i) => ({
    key  : b.bucket ?? `none-${i}`,
    label: b.bucket ? reasonLabel(b.bucket) : "-",
    value: b.count
  }));
  const total = items.reduce((s, x) => s + x.value, 0);

  return (
    <DetailCard title={t("dashboard.reasonBreakdown.title")} helpKey="order.returns-dashboard.section.reason-breakdown">
      {error && !data ? (
        <ListState state="error" onRetry={() => mutate()} />
      ) : total === 0 ? (
        <ListState state="empty" title={t("common.noData")} description={t("dashboard.reasonBreakdown.empty")} />
      ) : (
        <>
          <BarList items={items} />
          <Text size="sm" c="var(--nw-text-2)" mt="sm">{t("dashboard.chartLabel.returns", { count: total })}</Text>
        </>
      )}
    </DetailCard>
  );
}
